export default "__VITE_ASSET__jyvmKzqu__"